import { UploadGuideModal } from "@/components/flowly/UploadGuideModal/UploadGuideModal";
import { useLanguage } from "@/contexts/LanguageContext";
import { PROFILE_PHOTO_GUIDE_IMAGE } from "@/config/profilePhotoPresets";

interface ProfilePhotoUploadGuideProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Profile-photo copy for the shared upload-guide popup (shown once after the
 *  user's first upload). */
export function ProfilePhotoUploadGuide({
  isOpen,
  onClose,
}: ProfilePhotoUploadGuideProps) {
  const { t } = useLanguage();
  return (
    <UploadGuideModal
      isOpen={isOpen}
      onClose={onClose}
      imageSrc={PROFILE_PHOTO_GUIDE_IMAGE}
      title={t.profilePhoto.guideModalTitle}
      body={t.profilePhoto.guideModalBody}
      imageCaption={t.profilePhoto.guideImageCaption}
      ctaLabel={t.profilePhoto.guideModalCta}
    />
  );
}
